import authType from "./pushNotificationTypes";

const initialState = {
  isLoading: false,
  creating: false,
  sending: false,
  myTokens: {},
};

export default function pushNotificationReducer(state = initialState, action) {
  switch (action.type) {
    case authType.LOADING:
      return {
        ...state,
        isLoading: action.payLoad,
      };

    case authType.CREATING:
      return {
        ...state,
        creating: action.payLoad,
      };

    case authType.SENDING:
      return {
        ...state,
        sending: action.payLoad,
      };
    default:
      return state;
  }
}
